import { render } from "./ActivityTypeManagement.vue?vue&type=template&id=68722177"
import script from "./ActivityTypeManagement.vue?vue&type=script&lang=js"
export * from "./ActivityTypeManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__